(function(root){
  'use strict';
  const order=['49MAG','67MAG','82MAG','95MAG','MAXMAG'];
  function create(data){
    const bySku=new Map(data.products.map(p=>[p.sku,p]));
    // One conventional step-up ring maximum; never a step-down or a MAG-to-MAG conversion.
    function path(system,diameter){
      const adapters=data.products.filter(p=>p.kind==='adapter'&&p.system===system);
      const direct=adapters.filter(p=>p.diameter===diameter);
      if(direct.length) return {diameter,parts:[direct[0]],direct:true};
      const options=[];
      for(const a of adapters){
        const step=data.steps.find(s=>s.source===diameter&&s.target===a.diameter&&s.target>s.source);
        if(step) options.push({diameter,parts:[step,a],direct:false});
      }
      return options.sort((a,b)=>a.parts[1].diameter-b.parts[1].diameter)[0]||null;
    }
    function plan(system,sizes,lenses){
      const paths=sizes.map(d=>path(system,d));
      const lensPaths=lenses.map(id=>{const p=data.products.find(p=>p.kind==='lens'&&p.system===system&&p.lens===id);return p?{lens:id,parts:[p],direct:true}:null;});
      return paths.some(p=>!p)||lensPaths.some(p=>!p)?null:{system,paths:[...paths,...lensPaths]};
    }
    function options(sizes,lenses){
      if(!sizes.length&&!lenses.length) return [];
      return order.map(s=>plan(s,sizes,lenses)).filter(Boolean);
    }
    function required(plan,kit){
      const map=new Map();
      for(const path of plan.paths) for(const part of path.parts){
        if(kit&&part.kind==='adapter'&&kit.included.includes(part.diameter)) continue;
        if(kit&&part.kind==='lens'&&kit.includedLens===part.lens) continue;
        map.set(part.variant,part);
      }
      return [...map.values()];
    }
    function kits(system,lenses){
      return data.products.filter(p=>p.kind==='kit'&&p.system===system&&(!p.includedLens||lenses.includes(p.includedLens)));
    }
    return {path,plan,options,required,kits,bySku};
  }
  if(typeof module==='object'&&module.exports) module.exports={create};
  else root.JetMagEngine={create};
})(typeof window!=='undefined'?window:globalThis);
